/**
 * Initialize Google Address Validation on checkout page
 */
function initAutocomplete() {
    var $googleAddressAutocomplete = $("#google-address-autocomplete");
    var enableAddressAutocomplete = $googleAddressAutocomplete.data("enable-address-validation") || "";

    if (!enableAddressAutocomplete) {
        return;
    }

    var addressAutocompleteCountryCode = $googleAddressAutocomplete.data("address-validation-country-code") || "";
    var address1Field = getAddress1();
    var autoCompleteParams = {
        componentRestrictions: { country: [addressAutocompleteCountryCode] },
        fields: ["address_components", "geometry"],
        types: ["address"],
    };

    address1Field.each(function (i, address) {
        var autocomplete = new google.maps.places.Autocomplete(this, autoCompleteParams);
        autocomplete.inputId = this.id;
        populateAddressFields(autocomplete);
        autocomplete.addListener("place_changed", () => $("body").trigger("address:placeChanged", address));
    });
}

/**
 * Creates event and listens the address selection from autocomplete to populate the fields on address form.
 * @param {Object} autocomplete
 * @returns {Object} address1 dom element.
 */
function populateAddressFields(autocomplete) {
    google.maps.event.addListener(autocomplete, "place_changed", function () {
        var place = autocomplete.getPlace();
        var addressComponents = place.address_components;
        var inputName = getInputName();
        var address1 = "";
        var $form = $("#" + autocomplete.inputId).parents("form");

        if (addressComponents) {
            for (var i = 0; i < addressComponents.length; i++) {
                var componentType = addressComponents[i].types;
                var $postalCodeSelector =  $form.find("input[name$=" + inputName + "_postalCode]");
                var $citySelector = $form.find("input[name$=" + inputName + "_city]");
                var $countrySelector = $form.find("select[name$=" + inputName + "_country]");

                if ($(".registration-corporate").length) {
                    $postalCodeSelector = $form.find("input[name$=" + inputName + "_billingPostalCode]");
                    $citySelector = $form.find("input[name$=" + inputName + "_billingCity]");
                    $countrySelector = $form.find("select[name$=" + inputName + "_billingCountry]");
                }

                switch (componentType[0]) {
                    case "street_number":
                        address1 = `${addressComponents[i].long_name} ${address1}`;
                        break;
                    case "route":
                        address1 += addressComponents[i].short_name;
                        break;
                    case "postal_code":
                        $postalCodeSelector.val(addressComponents[i].long_name);
                        break;
                    case "locality":
                        $citySelector.val(addressComponents[i].long_name);
                        break;
                    case "postal_town":
                        $citySelector.val(addressComponents[i].long_name);
                        break;
                    case "country":
                        $countrySelector.val(addressComponents[i].short_name).trigger("change");
                        break;
                    default:
                        break;
                }
            }

            $("#" + autocomplete.inputId).val(address1);
        }
    });
}

/**
 * Returns current address1 form input for shipping or billing step.
 * @returns {Object} address1 dom element.
 */
function getAddress1() {
    var dataStage = getAddressLocation();
    var selectorAddress = "";
    switch (dataStage) {
        case "shipping":
            selectorAddress = $(".shippingAddressOne");
            break;
        case "payment":
            selectorAddress = $("#billingAddressOne");
            break;
        case "account":
            selectorAddress = $("#billingAddress1");
            break;
        default:
            selectorAddress = $("#address1");
            break;
    }
    return selectorAddress;
}


/**
 * Returns base input name according to current stage.
 * @returns {String} current base input name
 */
function getInputName() {
    var dataStage = getAddressLocation();
    var inputName = "";
    switch (dataStage) {
        case "shipping":
            inputName = "_shippingAddress_addressFields";
            break;
        case "payment":
            inputName = "_billing_addressFields";
            break;
        case "account":
            inputName = "_corporate";
            break;
        default:
            inputName = "_address";
            break;
    }
    return inputName;
}
/**
 * returns address location in account or in the checkout between billing and shipping
 * @returns {string} current address location
 */
function getAddressLocation() {
    var locationHref = window.location.href;
    var url = new URL(locationHref);
    var hasAddressType = url.searchParams.get("addressType");
    var siteLocation = "";

    if (hasAddressType) {
        return siteLocation;
    } else {
        var isShipping = locationHref.indexOf("shipping") > -1;
        siteLocation = isShipping ? "shipping" : "payment";
    }

    if ($(".registration-corporate").length) {
        siteLocation = "account";
    }

    return siteLocation;
}

module.exports = {
    initAutocomplete: initAutocomplete
};
